import { exitFullscreen } from "@fxid/shared";
import { Box, useMantineTheme } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { ContextModalProps } from "@mantine/modals";
import { openIframeModal } from "@shared/ui/Modal/OpenIframeModal.tsx";
import React from "react";

export type ModalInnerProps = {
	url: string;
	fullScreen?: boolean;
};

export const IframeModal = (props: ContextModalProps<ModalInnerProps>) => {
	const { url, fullScreen } = props.innerProps;
	const { height } = useViewportSize();
	const theme = useMantineTheme();

	void exitFullscreen();

	return (
		<Box
			style={{
				// Вместо theme.spacing.lg используем CSS-переменную var(--mantine-spacing-lg)
				minHeight: fullScreen ? `calc(${height}px - (var(--mantine-spacing-lg) * 2 + 28px))` : "50vh",
				display: "flex"
			}}
		>
			<iframe style={{ minHeight: "100%", width: "100%", border: "none" }} src={url}></iframe>
		</Box>
	);
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
window.test1 = () => openIframeModal({ url: "http://mozilla.org", fullScreen: true });
